<template>
  <div>
    <v-file-input
        ref="fileUpload"
        @change="handleImage"
        :label="'Upload ' + name"
        type="file"
        accept=".pdf"
        :loading="loading"
        :rules="rules">
    </v-file-input>
    <small class="tw-w-full tw-p-2">maximum of {{ size }} MB. PDF only</small>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ExpressUpload',
  data() {
    return {
      loading: false,
      value: null,
    };
  },
  props: {
    uid: {
      type: String,
      required: true,
    },
    phoneNumber: {
      type: String,
      required: true,
    },
    fullName: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 10,
    },
    bucket: {
      type: String,
      default: 'gi-policies',
      required: true,
    },
  },
  computed: {
    rules() {
      return [
        (v) => !!v || `${this.name} is required`,
        (v) => (v && v.size > 0) || `${this.name} is required`,
        (v) => (v && v.size <= this.size * 1024 * 1024) || `${this.name} must be less than ${this.size}MB`,
      ];
    },
  },
  methods: {
    async handleImage(file) {
      if (file) {
        this.loading = true;
        if (/\.(jpe?g|png|pdf)$/i.test(file.name)) {
          const FileSize = file.size / 1024 / 1024;
          if (FileSize > this.size) {
            this.$toast.error(`Image greater than ${this.size} MB`, 'Image Error');
            this.loading = false;
            return;
          }

          const reader = new FileReader();
          // let base64result;
          this.uploadData = await new Promise((resolve) => {
            reader.onload = () => {
              const base64result = /,(.+)/.exec(reader.result)[1];
              resolve({
                fileName: file.name,
                kraPinNumber: this.uid,
                img64: base64result,
                bucket: this.bucket,
                phoneNumber: this.phoneNumber,
                email: this.email,
                fullName: this.fullName,
              });
            };
            reader.readAsDataURL(file);
          });

          axios.post('/customer/quotation/upload', this.uploadData)
          // eslint-disable-next-line no-unused-vars
            .then((response) => {
              this.$toast.success('Documents uploaded successfully', 'Details');
              this.loading = false;
            });
        } else {
          this.$toast.error('Not Valid Document', 'Document Error');
          this.loading = false;
          this.$refs.fileUpload.reset();
        }
      }
    },
  },
};
</script>
